import React from "react";
import { useLocation } from "react-router-dom";

export default function useUserDropdownService() {
  const location = useLocation();

  const [key, setKey] = React.useState<number>(0);

  const incrementKey = React.useCallback(() => {
    setKey(k => k + 1);
  }, []);

  /**Since menuItems uses mousedown event, popover doesn't close on click, had to this workaround to get it working for our usecase */
  const randomKey = React.useMemo(() => {
    return location.pathname.toString() + key;
  }, [key, location.pathname]);

  return {
    incrementKey,
    randomKey
  };
}
